import * as React from "react"
import { FaUser } from "react-icons/fa";
const UserIcon = (props) => (
    <FaUser size={ 20 }
    />
)
export default UserIcon
